import './src/global.css';
import '@dls/web/fonts.css';
import 'regenerator-runtime/runtime';
import React from 'react';
import { ThemeProvider } from '@dls/web';
import { web as dlsTheme } from '@dls/themes';

export const renderWithTheme = element => (
  <ThemeProvider theme={dlsTheme.dlsStandard}>{element}</ThemeProvider>
);

export const wrapRootElement = ({ element }) => renderWithTheme(element);
